import React from 'react';
import clsx from 'clsx';

import TypeCard from './TypeCard';

import './cards.scss';

const Cards = (props) => {

  const { className, children, ...restProps } = props;

  return (
    <div
      className={clsx('cards-container', className)}
      {...restProps}
    >
      {children}
    </div>
  );
};

export { Cards as default, TypeCard };
